export const REQUEST_ORDER_STATUS = [
  'order.status.preparing',
  'order.status.loading',
  'order.status.in_transit',
  'order.status.arrived',
];
